import { ProductIdentifiers } from '@/lib/definitions/types'
import RouterIcon from '@fluent-icons/router-24-regular'
import ConnectorIcon from '@fluent-icons/connector-24-regular'
import GlobeShieldRegular from '@fluent-icons/globe-shield-24-regular'
import GlobeIcon from '@fluent-icons/globe-24-regular'
import CloudFlowIcon from '@fluent-icons/cloud-flow-24-regular'
import GroupIcon from '@fluent-icons/group-24-regular'
import PlugConnectedCheckmarkIcon from '@fluent-icons/plug-connected-checkmark-20-regular'
import ChannelShareIcon from '@fluent-icons/channel-share-28-filled'
import KeyIcon from '@fluent-icons/key-24-regular'
import NetworkCheckIcon from '@fluent-icons/network-check-24-regular'
import ArrowAutofitWidthDottedIcon from '@fluent-icons/arrow-autofit-width-dotted-24-regular'
import ArrowCircleDownSplitIcon from '@fluent-icons/arrow-circle-down-split-24-regular'
import ArrowMinimizeIcon from '@fluent-icons/arrow-minimize-24-regular'
import ArrowSortIcon from '@fluent-icons/arrow-sort-24-regular'
import ArrowSwapIcon from '@fluent-icons/arrow-swap-24-regular'
import CommunicationIcon from '@fluent-icons/communication-24-regular'
import CloudSwapIcon from '@fluent-icons/cloud-swap-24-regular'

// assets
import PortIcon from '@/assets/icons/port.svg?react'
import LagIcon from '@/assets/icons/lag.svg?react'

export const ProductIcons = {
  ip_transit: RouterIcon,
  ip_access: RouterIcon,
  flex_ethernet: ConnectorIcon,
  ddos_protection: GlobeShieldRegular,
  generic: GlobeIcon,
  cloud_connect: CloudFlowIcon,
  group: GroupIcon,
  plug_connected_checkmark: PlugConnectedCheckmarkIcon,
  flex_peer: ChannelShareIcon,
  key: KeyIcon,
  network_check: NetworkCheckIcon,
  arrow_autofit_width_dotted: ArrowAutofitWidthDottedIcon,
  arrow_circle_down_split: ArrowCircleDownSplitIcon,
  arrow_minimize: ArrowMinimizeIcon,
  arrow_sort: ArrowSortIcon,
  arrow_swap: ArrowSwapIcon,
  communication: CommunicationIcon,
  cloud_swap: CloudSwapIcon,
  port_icon: PortIcon,
  lag_icon: LagIcon,
}

const PRODUCT_PID_TO_ICON_KEY: Partial<
  Record<string, keyof typeof ProductIcons>
> = {
  [ProductIdentifiers.IP_TRANSIT]: 'ip_transit',
  [ProductIdentifiers.LEGACY_IP_TRANSIT]: 'ip_transit',
  [ProductIdentifiers.IP_ACCESS]: 'ip_access',
  [ProductIdentifiers.LEGACY_IP_ACCESS]: 'ip_access',
  [ProductIdentifiers.IP_TRANSIT_OVER_GRE]: 'cloud_swap',
  [ProductIdentifiers.FLEX_ETHERNET_ENDPOINT]: 'flex_ethernet',
  [ProductIdentifiers.LAYER2]: 'flex_ethernet',
  [ProductIdentifiers.LEGACY_FLEX_ETHERNET]: 'flex_ethernet',
  [ProductIdentifiers.FLEX_PEER_ENDPOINT]: 'flex_peer',
  [ProductIdentifiers.DDOS_PROTECTION]: 'ddos_protection',
  [ProductIdentifiers.SE_DDOS_PROTECTION]: 'ddos_protection',
  [ProductIdentifiers.CLOUD_CONNECT]: 'cloud_connect',
  [ProductIdentifiers.SE_CLOUD_CONNECT]: 'cloud_connect',
  [ProductIdentifiers.EN_ETHERNET]: 'flex_ethernet',
  [ProductIdentifiers.EN_INTERNET]: 'ip_transit',
}

export function resolveProductIconId(
  productId: string
): keyof typeof ProductIcons {
  if (productId && productId in ProductIcons) {
    return productId as keyof typeof ProductIcons
  }
  const fromPid = PRODUCT_PID_TO_ICON_KEY[productId]
  if (fromPid) return fromPid
  return 'generic'
}

interface ProductIconProps {
  productId: string
  className?: string
  size?: number
}

export const ProductIcon = ({
  productId,
  className,
  size,
}: ProductIconProps) => {
  const resolved = resolveProductIconId(productId)
  const Icon = ProductIcons[resolved]

  return <Icon className={className} fontSize={size} />
}
